// Split.io configuration for A/B testing and feature flags

// Environment detection - align with your existing env setup
const getEnvironment = () => {
    // Check if this is running in the checkout context with explicit env
    if (typeof window !== 'undefined' && window.lendicaConfig?.env) {
        return window.lendicaConfig.env;
    }

    // Skip environment variables for simplicity
    if (process.env.REACT_APP_ENV) {
        return process.env.REACT_APP_ENV;
    }

    // Fallback to hostname detection
    if (typeof window !== 'undefined') {
        const hostname = window.location.hostname;
        if (hostname.includes('app-idev') || hostname.includes('localhost')) {
            return 'idev';
        }
        return 'prod';
    }

    return 'idev'; // Default to development
};

const env = getEnvironment();

// Export environment for debugging/logging
export { env };

export const splitConfig = {
    core: {
        authorizationKey:
            env === 'idev'
                ? 'p9aq6gjcu5qh00tjqp5nf0csv47nhmp439ej' // Development environment
                : env === 'prod'
                ? 'q7kvvl07d8khtd4ckralrfvsajjt8juluhas' // Production environment
                : 'localhost', // Local development fallback
        key: 'user-key', // This will be dynamically updated with actual user ID
    },
    scheduler: {
        featuresRefreshRate: 30, // 30 seconds
        segmentsRefreshRate: 60, // 60 seconds
        metricsRefreshRate: 300, // 5 minutes
        impressionsRefreshRate: 300, // 5 minutes
    },
    startup: {
        readyTimeout: 10000, // 10 seconds
        requestTimeoutBeforeReady: 15000, // 15 seconds
    },
    debug: env === 'idev', // Enable debug mode in development
};

// Feature flag names - keep these in sync with Split dashboard
export const FEATURE_FLAGS = {
    LEAD_FORM_TEST: 'lead_form',
    // Add more feature flags here as needed
};

// Helper function to get user identifier for Split
export const getUserKey = () => {
    // Priority: HubSpot cookie > localStorage > generated ID
    const getHubSpotVisitorToken = () => {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [name, value] = cookie.trim().split('=');
            if (name === 'hubspotutk') {
                return value;
            }
        }
        return null;
    };

    const hubspotToken = getHubSpotVisitorToken();
    if (hubspotToken) {
        return `hs_${hubspotToken}`;
    }

    // Fall back to localStorage
    const storageKey = 'split_user_key';
    let userId = localStorage.getItem(storageKey);

    if (!userId) {
        userId = `local_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
        localStorage.setItem(storageKey, userId);
    }

    return userId;
};

// Helper function to get user attributes for targeting
export const getUserAttributes = () => {
    return {
        user_id_source: document.cookie.includes('hubspotutk') ? 'hubspot' : 'localStorage',
        // Add more attributes for targeting as needed
        // browser: navigator.userAgent,
        // timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };
};
